// rateListModalSlice.js

import { createSlice } from "@reduxjs/toolkit";

const rateListModalSlice = createSlice({
  name: "rateListModal",
  initialState: {
    selectedRate: null,
  },
  reducers: {
    setSelectedRate(state, action) {
      state.selectedRate = action.payload;
    },
    resetSelectedRate(state) {
      console.log("resetSelectedRate action dispatched");
      state.selectedRate = null;
    },
  },
});

export const { setSelectedRate, resetSelectedRate } =
  rateListModalSlice.actions;

export default rateListModalSlice.reducer;
